import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tooltip component for the WorldMap.
 * Shows country name, status counts, and confirmation rate on hover.
 */
const WorldMapTooltip = ({ country, statusCounts, visible, position }) => {
  if (!visible || !country) return null;

  const total = statusCounts.total || 0;
  const confirmed = statusCounts.confirmed || 0;
  const confirmationRate = total > 0 ? ((confirmed / total) * 100).toFixed(1) : '0.0';

  return (
    <div
      data-testid="world-map-tooltip"
      style={{
        position: 'fixed',
        left: position.x + 12,
        top: position.y - 10,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        color: '#fff',
        padding: '10px 14px',
        borderRadius: '6px',
        fontSize: '0.8rem',
        pointerEvents: 'none',
        zIndex: 1000,
        minWidth: '180px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: '0.9rem',
          marginBottom: '6px',
          borderBottom: '1px solid rgba(255,255,255,0.2)',
          paddingBottom: '4px',
        }}
      >
        {country}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>New:</span>
        <span style={{ fontWeight: 600 }}>{statusCounts.new || 0}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Pending HR:</span>
        <span style={{ fontWeight: 600 }}>{statusCounts.pendinghr || 0}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Pending BTT:</span>
        <span style={{ fontWeight: 600 }}>{statusCounts.pendingbtt || 0}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Pending DES:</span>
        <span style={{ fontWeight: 600 }}>{statusCounts.pendingdes || 0}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Confirmed:</span>
        <span style={{ fontWeight: 600 }}>{statusCounts.confirmed || 0}</span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '6px',
          paddingTop: '4px',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          fontWeight: 700,
        }}
      >
        <span>Confirmation Rate:</span>
        <span>{confirmationRate}%</span>
      </div>
    </div>
  );
};

WorldMapTooltip.propTypes = {
  country: PropTypes.string.isRequired,
  statusCounts: PropTypes.shape({
    new: PropTypes.number,
    pendinghr: PropTypes.number,
    pendingbtt: PropTypes.number,
    pendingdes: PropTypes.number,
    confirmed: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  visible: PropTypes.bool.isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
};

export default WorldMapTooltip;
